import { pdfjs } from 'react-pdf';

// ✅ Point directly to CDN or public path fallback
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
